document.addEventListener('DOMContentLoaded', function() {
    const productItems = document.querySelectorAll(".product-item");
    productItems.forEach((productItem) => {
        const {
            handle
        } = productItem.dataset
        const fetchSwatches = async () => {
            if (document.querySelector('.swatches')) {
                return;
            }
            const generateSrcSet = (image) => {
                const sizes = [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1600];
                return sizes.map(size => `${image}&width=${size} ${size}w`).join(', ');
            };
            const elements = {
                anchors: productItem.querySelectorAll('a'),
                price: productItem.querySelector('.product-item__price')
            };
            const { root } = window.theme.routes;
            const resp = await fetch(`${root !== '/' ? root : ''}/products/${handle}?view=swatches`);
            const swatches = await resp.text();
            const swatchEl = document.createElement('div');
            swatchEl.innerHTML = swatches;
            const swatchContainer = swatchEl.querySelector('.swatches');
            swatchEl.querySelectorAll('.product__color-swatch').forEach(swatch => {
                const {
                    handle,
                    imageMain,
                    imageSecondary
                } = swatch.dataset;
                let imageMainSrcSet;
                let imageHoverSrcSet;
                const url = elements.anchors[0].href.replace(/\/products\/[\d|\w|-]+/, `/products/${handle}`);
                function handleClickAndFocus(ev) {
                    ev.stopPropagation();
                    ev.preventDefault();
                    elements.imageFeatured = elements.imageFeatured || productItem.querySelector('.product-item__image--one img');
                    elements.imageHover = elements.imageHover || productItem.querySelector('.product-item__image--two img');
                    imageMainSrcSet = imageMainSrcSet || generateSrcSet(imageMain);
                    imageHoverSrcSet = imageHoverSrcSet || generateSrcSet(imageSecondary);
                    elements.anchors.forEach((anchor) => {
                        anchor.href = url;
                    });
                    swatchEl.querySelectorAll('.product__color-swatch').forEach(el => {
                        el.classList.toggle('swatch-selected', el === swatch);
                    });
                    elements.imageFeatured.srcset = imageMainSrcSet
                    elements.imageHover.srcset = imageHoverSrcSet
                }
                swatch.addEventListener('click', handleClickAndFocus);
                swatch.addEventListener('focus', handleClickAndFocus);
            });
            elements.price.after(swatchEl);
            elements.price.after(swatchEl);
            // focus event listener for keyboard
            const anchors = productItem.querySelectorAll('.product-item__image-link');
            anchors.forEach((anchor) => {
                anchor.addEventListener('focus', function() {
                    if (swatchContainer) {
                        swatchContainer.classList.remove('hidden');
                    }
                });
            });
            const isMobile = window.innerWidth < 720;
            if (!isMobile) {
                productItem.addEventListener('mouseover', function() {
                    swatchContainer.classList.remove('hidden');
                })
                productItem.addEventListener('mouseout', function() {
                    swatchContainer.classList.add('hidden');
                })
            }
        };
        fetchSwatches();
    })
});
